module.exports = __webpack_public_path__ + "media/npc_dota_hero_undying.a0ee43fd.webm";